import { format, isValid, parse } from 'date-fns';
import type { ExcelColumnMapping } from './types';

const formatDate = (value?: string | null) => {
  if (!value) return '';
  const cleaned = value.replace(/[^0-9]/g, '');
  if (cleaned.length !== 8) return value;
  const parsed = parse(cleaned, 'yyyyMMdd', new Date());
  if (!isValid(parsed)) return value;
  return format(parsed, 'dd/MM/yyyy');
};

export const SO_CHI_TIET_CONG_NO_THEO_KHACH_HANG_COLUMNS: ExcelColumnMapping[] = [
  { header: 'Đơn vị', width: 18, resolver: row => row.ma_unit ?? row.unit_id ?? '' },
  { header: 'Ngày c/từ', width: 16, resolver: row => formatDate(row.ngay_ct) },
  { header: 'Số c/từ', width: 18, resolver: row => row.so_ct ?? '' },
  { header: 'Ngày hóa đơn', width: 16, resolver: row => formatDate(row.ngay_ct0) },
  { header: 'Số hóa đơn', width: 18, resolver: row => row.so_ct0 ?? '' },
  { header: 'Tài khoản', width: 14, resolver: row => row.tk ?? '' },
  { header: 'Tk đối ứng', width: 14, resolver: row => row.tk_du ?? '' },
  { header: 'Diễn giải', width: 30, resolver: row => row.dien_giai ?? '' },
  { header: 'Ps nợ', width: 18, resolver: row => Number(row.ps_no ?? 0) },
  { header: 'Ps có', width: 18, resolver: row => Number(row.ps_co ?? 0) },
  { header: 'Mã c/từ', width: 16, resolver: row => row.ma_ct ?? '' }
];
